import {
  FiLink,
  FiLink2,
  FiLogOut,
  FiSettings,
  FiShield,
  FiSlash,
} from 'react-icons/fi'
import { NavLink } from 'react-router-dom'
import * as driveService from '../../services/driveService'
import {
  Avatar,
  Box,
  Chip,
  Divider,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material'
import { useUIStore } from '../../stores/useUIStore'
import { useAuthContext } from '../../contexts/AuthContext'
import { useChatStore } from '../../stores/useChatStore'
import { useShallow } from 'zustand/react/shallow'

const UserMenu = () => {
  const { user, fetchUser, token, logout } = useAuthContext()

  const { isUserMenuOpen, setIsUserMenuOpen, setIsSettingsModalOpen } = useUIStore(
    useShallow(state => ({
      isUserMenuOpen: state.isUserMenuOpen,
      setIsUserMenuOpen: state.setIsUserMenuOpen,
      setIsSettingsModalOpen: state.setIsSettingsModalOpen,
    }))
  )

  const isAdmin = user?.roles?.includes(
    process.env.REACT_APP_ADMIN_ROLE_NAME || 'admin'
  )

  const handleDisconnectDrive = async () => {
    if (!token) return
    try {
      await driveService.disconnectDrive(token)
      await fetchUser(token)
    } catch (e) {
      console.error('Failed to disconnect drive', e)
      useChatStore
        .getState()
        .setError(e.response?.data?.detail || 'Impossibile disconnettere Google Drive.')
    }
    setIsUserMenuOpen(false)
  }

  return (
    <Menu
      anchorEl={isUserMenuOpen}
      open={Boolean(isUserMenuOpen)}
      onClose={() => setIsUserMenuOpen(null)}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      {/* Header */}
      <MenuItem disabled>
        <Avatar
          src={user?.profile_picture || '/default-avatar.png'}
          sx={{ width: 40, height: 40, mr: 1 }}
        />
        <Box>
          <Typography variant="subtitle1">{user?.display_name || 'Utente'}</Typography>
          <Typography variant="body2" color="text.secondary">
            {user?.sfre_email}
          </Typography>
          {user?.team && <Chip label={user.team} color="primary" size="small" />}
        </Box>
      </MenuItem>

      <Divider />

      {/* Settings */}
      <MenuItem
        onClick={() => {
          setIsSettingsModalOpen(true)
          setIsUserMenuOpen(null)
        }}
      >
        <ListItemIcon>
          <FiSettings size={18} />
        </ListItemIcon>
        Impostazioni
      </MenuItem>

      {/* Admin */}
      {isAdmin && (
        <MenuItem
          component={NavLink}
          to="/admin/dashboard"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => setIsUserMenuOpen(null)}
        >
          <ListItemIcon>
            <FiShield size={18} />
          </ListItemIcon>
          Pannello Admin
        </MenuItem>
      )}

      <Divider />

      {/* Google Drive connect/disconnect */}
      {user?.is_google_drive_connected ? (
        <MenuItem onClick={handleDisconnectDrive}>
          <ListItemIcon>
            <FiLink2 size={18} />
            <FiSlash size={14} style={{ marginLeft: -12, color: 'red' }} />
          </ListItemIcon>
          Disconnetti Google Drive
        </MenuItem>
      ) : (
        <MenuItem onClick={driveService.connectDrive}>
          <ListItemIcon>
            <FiLink size={18} />
          </ListItemIcon>
          Connetti Drive
        </MenuItem>
      )}

      {/* Logout */}
      <MenuItem onClick={logout}>
        <ListItemIcon>
          <FiLogOut size={18} />
        </ListItemIcon>
        Esci
      </MenuItem>
    </Menu>
  )
}

export default UserMenu
